import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
//import SinglePicsPage from '../components/SinglePics'
import ProjectPage from '../components/ProjectPage'

const projectElements = {
	images: [
		{
		"src": "DigitalCollage/Street_Walker",
		"orientation": "portrait"
		},
		{
		"src": "DigitalCollage/Spaceship_Jumpers",
		"orientation": "portrait"
		},
		{
		"src": "DigitalCollage/Freedom_of_Waiting",
		"orientation": "portrait"
		},
		{
		"src": "DigitalCollage/Dessert_Hike",
		"orientation": "portrait"
		},
		{
		"src": "DigitalCollage/Underwater_World",
		"orientation": "portrait"
		},
		{
		"src": "DigitalCollage/Love_Hate_Relationship",
		"orientation": "portrait"
		},
		//"src": "DigitalCollage/Reflections_of_Phantasy",
		//"orientation": "portrait"
		//},
		{
		"src": "DigitalCollage/Inbetween_Worlds",
		"orientation": "portrait"
		},
		{
		"src": "DigitalCollage/Bedtime_Story",
		"orientation": "portrait"
		}
	]
}

export default class CollagePage extends React.Component {
	render(){
		return(
			<ProjectPage 
			title="Digital Collage" 
			text="Schon in meiner Schulzeit habe ich an Papier-Collagen gearbeitet. Im Jahr 2019 habe ich begonnen die Technik der Collage 
			im Digitalen einzusetzen. Mittlerweile habe ich an mehreren digitalen Collagen gearbeitet. Das verwendete Bildmaterial der Collagen stammt von Unsplash." 
			images={projectElements.images}
			layout={'zweier'}/>
		) 
	}
}





// WEBPACK FOOTER //
// ./src/pages/collage.js